import request from '../../axios';

export const postCreateBrand = async (payload: FormData) => {
  const response = await request.post(
    `api/v2/store/list-create/brand`,
    payload,
  );

  return response;
};
